<!-- eslint-disable max-len -->
<template>
  <svg
    :width="size"
    :height="size"
    class="text-red-500"
    :fill="color"
    version="1.1"
    viewBox="0 0 700 700"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g>
      <path
        d="m350 95.203c-101.86 0-184.8 82.938-184.8 184.8 0 101.86 82.938 184.8 184.8 184.8s184.8-82.938 184.8-184.8c0-101.86-82.938-184.8-184.8-184.8zm0 33.602c83.703 0 151.2 67.496 151.2 151.2s-67.496 151.2-151.2 151.2-151.2-67.496-151.2-151.2 67.496-151.2 151.2-151.2zm0 28c-9.2773 0-16.801 7.5234-16.801 16.801v106.4c0 4.6406 1.8594 8.8594 4.8984 11.898l67.375 67.375c6.5625 6.5625 17.238 6.5625 23.801 0 6.5625-6.5586 6.5625-17.238 0-23.801l-62.473-62.477v-99.398c0-9.2773-7.5195-16.801-16.801-16.801z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: 'clock',
  props: {
    color: {
      type: String,
      default: '#FF3232',
    },
    size: {
      type: String,
      default: '30px',
    },
  },
};
</script>
